(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-chat"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('.wa').forEach(r => {
    const p = r.querySelector('[popover]');
    if (!p || r.dataset.ready) return;
    r.dataset.ready = '1';
    let seen = false;
    try { seen = sessionStorage.getItem('wa-seen'); } catch (e) {}
    if (seen) r.classList.add('is-seen');
    const markSeen = () => { r.classList.add('is-seen'); try { sessionStorage.setItem('wa-seen', '1'); } catch (e) {} };
    p.addEventListener('toggle', e => { if (e.newState === 'open') markSeen(); });
    if (!('popover' in HTMLElement.prototype)) {
      r.querySelector('.wa__btn').addEventListener('click', () => { p.classList.toggle('is-open'); markSeen(); });
      r.querySelector('.wa__x').addEventListener('click', () => p.classList.remove('is-open'));
    }
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

  } catch(e) { console.error(e); }
})();
})();
